import { Avatar, Box, Button, Stack, TextField, Typography } from "@mui/material"
import { useContext, useState } from "react"
import moment from 'moment'

import EditIcon 		from '@mui/icons-material/Edit';
import DeleteIcon 		from '@mui/icons-material/Delete';

import AuthContext 		from "../../context/AuthProvider";
import ConfirmDialog 	from "../ConfirmDialog";

const ThreadReply = ({reply, onPost, onDelete}) => {
	const {auth}										= useContext(AuthContext)

	const [isDeleteConfirmOpen, setIsDeleteConfirmOpen]	= useState(false)
	const [selectedPostId, setSelectedPostId]			= useState()
	const [isEditing, setIsEditing]						= useState(false)
	const [isPosting, setIsPosting]						= useState(false)
	const [text, setText]								= useState(reply.text)

	const deletePost									= onDelete
	const savePost										= onPost

	const handleConfirmation = (id) => {
		setSelectedPostId(id)
		setIsDeleteConfirmOpen(true)
	}

	const handlePostSave = (postId, title, text, companyId, parentId) => {
		setIsPosting(true)
		savePost(postId, title, null, text, companyId, parentId)
		.then(() => {
			setIsEditing(false)
			setIsPosting(false)
		})
	}

	return (
		<Box width={'100%'} borderRadius={1} boxShadow={2} marginTop={1}>
			
			<ConfirmDialog 
				title="Aviso"
				children="Tem certeza que deseja exluir o registro?"
				open={isDeleteConfirmOpen}
				setOpen={setIsDeleteConfirmOpen}
				onConfirm={() => deletePost(selectedPostId)}
			/>

			<Stack direction={'row'} sx={{alignItems: 'center'}} padding={1} bgcolor={'#DCDCDC'} borderRadius={'4px 4px 0px 0px'}>
				<Avatar></Avatar>
				<Typography variant="caption" marginLeft={1} flex={1}>
					Postado por {reply.user.username} em {moment(reply.createdAt).format('DD/MM/YYYY HH:mm')}
				</Typography>
				{auth.user === reply.user.username ? (
					<>
						<EditIcon color="primary" fontSize="small" onClick={() => setIsEditing(true)}/>
						<DeleteIcon color="primary" fontSize="small" onClick={() => handleConfirmation(reply.id)}/>				
					</>
				) : null }
			</Stack>

			{/* CASO ESTEJA EDITANDO, MOSTRA OS CAMPOS PARA EDICAO, SENAO, MOSTRA O TEXTO */}
			{ isEditing ? (
				<Box sx={{p: 1}}>
					<TextField fullWidth multiline rows={4} value={text} onChange={e => setText(e.target.value)}/>
					<Stack direction={'row'} width={'100%'} justifyContent={'right'} marginTop={1} spacing={1}>
						<Button variant="contained" color='secondary' onClick={() => setIsEditing(false)}>Cancelar</Button>
						<Button variant="contained" onClick={() => handlePostSave(reply.id, reply.title, text, reply.companyId, reply.parentId)} disabled={isPosting}>Salvar</Button>
					</Stack>
				</Box>
			):(
				<Typography padding={1}>{text}</Typography>
			)}

		</Box>
	)
}

export default ThreadReply